/**
 * LES PHOTOS D'EMBALLAGE
 * ======================
 *
 * Le nom d'emballage vient du fichier « all product » et n'est pas saisi
 * deux fois de la meme facon : « sac craft legume 2 kg » dans une feuille,
 * « Sac kraft 2 kg » dans une autre. On compare donc sur une forme reduite
 * — minuscules, sans accents, sans ponctuation — plutot que sur le texte
 * exact : sinon la moitie des articles n'aurait pas d'image pour une
 * majuscule.
 *
 * « origine » ne renvoie rien, volontairement : c'est l'emballage du
 * fournisseur, il sait a quoi il ressemble.
 */

const PHOTOS: Array<{ cles: string[]; url: string }> = [
  { cles: ["craft epice 250 g", "craft epice 250g", "sac craft epice 250 g"], url: "/emballages/craft-epice-250.jpg" },
  { cles: ["craft epice 500 g", "craft epice 500g", "sac craft epice 500 g"], url: "/emballages/craft-epice-500.jpg" },
  { cles: ["boite plastique 250g", "boite plastique 250 g", "boite plastic 250 g"], url: "/emballages/boite-plastique-250.jpg" },
  { cles: ["boite plastique 500 g", "boite plastique 500g"], url: "/emballages/boite-plastique-500.jpg" },
  { cles: ["boite plastique 1 kg", "boite plastique 1kg"], url: "/emballages/boite-plastique-1kg.jpg" },
  { cles: ["sac craft legume 2 kg", "sac kraft 2 kg", "sac craft 2 kg", "sac kraft legume 2 kg"], url: "/emballages/sac-kraft-2kg.jpg" },
];

/** Minuscules, sans accents, espaces tasses : la forme qu'on compare. */
function reduire(v: unknown): string {
  return String(v ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

const INDEX = new Map<string, string>();
for (const p of PHOTOS) {
  for (const c of p.cles) INDEX.set(reduire(c), p.url);
}

/** La photo de cet emballage, ou null quand on n'en a pas (dont « origine »). */
export function photoEmballage(nom: unknown): string | null {
  const cle = reduire(nom);
  if (!cle || cle === "origine") return null;
  return INDEX.get(cle) || null;
}
